var $=jQuery.noConflict();
$(document).ready(function($) {
	
	/*================ UI ================*/
  
	$( function() {
		$( ".ui-tabs" ).tabs({
			heightStyle: "content",
			load: clickToOpenTab()
		});
		
		function clickToOpenTab() {
			$('.open-tab').click(function (event) {
				event.preventDefault();
				var tab = $(this).attr('data-tab');
				var tab_index = $('.ui-tabs-panel').index( $(tab) );
				$('html, body').animate({
					scrollTop: $('.ui-tabs').offset().top
				}, 1000);
				$('.ui-tabs').tabs('option', 'active', tab_index);
	    });
		}
		
		$( ".ui-accordion" ).accordion({
			collapsible: true
		});
		
		$( ".ui-accordion-collapsed" ).accordion({
			active: false,
			collapsible: true
		});
		
		$('.slick-carousel').slick({
		  slidesToShow: 4,
			responsive: [
				{
				  breakpoint: 480,
				  settings: {
				    slidesToShow: 2
				  }
				}
			]
		});
		$('#list-collection').slick({
		  slidesToShow: 3,
		  arrows:true,
			responsive: [
				{
				  breakpoint: 768,
				  settings: {
				    slidesToShow: 2
				  }
				},
				{
				  breakpoint: 480,
				  settings: {
				    slidesToShow: 1
				  }
				}
			]
		});
	});
	$('.collection-filter .block ').each(function() {
	    var self = $(this);
	    var totalItemF = self.find('.block-content .filter-list li').length;
	    if (totalItemF < 1) {
	        self.addClass('hidden');
	    } else {
	        self.removeClass('hidden');
	    }
	});
    if ($('.block-content .filter-list li').length < 1) {
        $('.template-collection .main-content ').addClass('no-filter-tag');
    } else {
        $('.template-collection .main-content ').removeClass('no-filter-tag');
    }
    if ($('.item-collection').length < 1) {
        $('.top-collection').addClass('no-bg-collection');
    } else {
        $('.top-collection .main-content ').removeClass('no-bg-collection');
    }
	$('#product_grid .product_item ').each(function() {
		var countColor = 5;
		var self = $(this);
		var totalCountColor = self.find('.swatch_content .swatch-element').length;
		var loadMore = self.find('#countSwatch');
		loadMore.html('+' + (totalCountColor - countColor));
		self.find('.swatch_content .swatch-element:lt(' + countColor + ')').show();
		loadMore.click(function () {
		    countColor =self.find('.swatch_content .swatch-element:visible').length;
		    self.find('.swatch_content .swatch-element:lt(' + (countColor + 5) + ')').show();
		    if (countColor + 5 >= self.find('.swatch_content .swatch-element').length) {
		        $(this).hide();
		    } else {
		    	$(this).html('+' + (totalCountColor - $('.swatch_content .swatch-element:visible').length));
		    }
		});	
	});
	$('.qtybox .btnqty').on('click', function(){
      var qty = parseInt($(this).parent('.qtybox').find('.quantity-input').val());
      if($(this).hasClass('qtyplus')) {
        qty++;
      }else {
        if(qty > 1) {
          qty--;
        }
      }
      qty = (isNaN(qty))?1:qty;
      $(this).parent('.qtybox').find('.quantity-input').val(qty);
      $('input[type=submit].cart__update').click();
    }); 
	$('.SidebarFilter .title-tag').click(function () {
		$('.cc-tabs--accordion-mode').toggle();
		if($('.SidebarFilter .title-tag').hasClass('show')){
			$('.SidebarFilter .title-tag').removeClass('show');

		}else{
			$('.SidebarFilter .title-tag').addClass('show');
		}
	});	
	//Check Current Tag
	let currentTag = $('.cc-tabs--accordion-mode').attr('tag-current');
    $('.cc-tabs__tab__panel ul li').each(function(){
    	var self = $(this);
        var tagItem = self.attr('data-tag');
        if(currentTag != null && currentTag === tagItem){
            if(self.hasClass('item-active')){
                self.removeClass('item-active');
            }else{
            	self.addClass('item-active');
            }
        }
    });
});

/* Smooth Scroll On Anchors */
$(function() {
  $('a[href*="#"]:not([href="#"]):not(.noscroll)').click(function() {
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
      if (target.length) {
        $('html, body').animate({
          scrollTop: target.offset().top - 80
        }, 1000);
        return false;
      }
    }
  });
});

/* Free Shipping Bar */
function animateFreeShippingThreshold() {
	var threshold = $('.free_shipping_progress_bar').attr('data-threshold');
	var total = $('.free_shipping_progress_bar').attr('data-total');
	var percentage = total / threshold * 100;
	if ( percentage > 100 ) percentage = 100;
	if ( percentage >= 100 ) {
		$('.free_shipping_progress .status').hide();
		$('.free_shipping_progress .qualified').show();
	} else {
		$('.free_shipping_progress .status').show();
		$('.free_shipping_progress .qualified').hide();
	}
	$('.free_shipping_progress_bar .progress').animate({ width: percentage + '%' }, 1000, function() {
		if ( percentage >= 100 ) $('.free_shipping_progress').addClass('threshold_reached');
	});
}
function recalculateShippingThreshold(new_total) {
	var threshold = $('.free_shipping_progress .free_shipping_progress_bar').attr('data-threshold');
	var new_threshold_diff = threshold - new_total;
	$('.free_shipping_progress_bar').attr('data-total', new_total);
	$('.free_shipping_progress .status .money').text((new_threshold_diff/100).toFixed( 2 ).replace('.00', '') );
	if ( new_threshold_diff > 0 ) {
		$('.free_shipping_progress .status').show();
		$('.free_shipping_progress .qualified').hide();
	} else {
		$('.free_shipping_progress .status').hide();
		$('.free_shipping_progress .qualified').show();
	}
	animateFreeShippingThreshold();
}
function initQuickviewJs() {
	$('#popup-quickview .quickview-popup-content .owl-carousel').slick({
		infinite: true,
		slidesToShow: 1,
		dots: true,
		arrows: false,
		speed: 500,
		fade: true,
		centerMode: true,
		cssEase: 'linear'
	});
    $('#popup-quickview').addClass('loaded');
    $('.single-option-selector').on(
		'change',
		function () {
			var variant = _getVariantFromOptions();

		      if (!variant) {
		        return;
		      }

			  if (!variant.available) {
				  $('#AddToCartText-product-template').text("Épuisé");
				  $('#AddToCart-product-template').attr('disabled', true);
			  } else {
				  $('#AddToCartText-product-template').text("Ajouter au panier");
				  $('#AddToCart-product-template').attr('disabled', false);
			  }
          
          	  
          if(variant.featured_media != null){
			  var slideNumber = $('.slick-track').find(`[data-media-id='-${variant.featured_media.id}']`).parent().parent().parent().index();

			 $('.owl-carousel').slick('slickGoTo', slideNumber );
          }

		      $('#ProductSelect-product-template').val(variant.id);
        }
		
    );

    function _getCurrentOptions() {
      var currentOptions = _.map(
        $('.single-option-selector'),
        function(element) {
          var $element = $(element);
          var currentOption = {};
          currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
        }
      );

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = _.compact(currentOptions);

      return currentOptions;
    }

    function _getVariantFromOptions() {
      var selectedValues = _getCurrentOptions();
      var variants = JSON.parse(document.getElementById('ProductJson-quickview').textContent).variants;
      // console.log(variants);
      // console.log(selectedValues);

      var found = _.find(variants, function(variant) {
        return selectedValues.every(function(values) {
          return _.isEqual(variant[values.index], values.value);
        });
      });

      return found;
    }
	
	var onLoadVariant = _getVariantFromOptions();

	if (!onLoadVariant) {
	return;
	}
  if(onLoadVariant.featured_media != null){
	var onLoadSlideNumber = $('.slick-track').find(`[data-media-id='-${onLoadVariant.featured_media.id}']`).parent().parent().parent().index();

	$('.owl-carousel').slick('slickGoTo', onLoadSlideNumber );
  }

	$('#ProductSelect-product-template').val(onLoadVariant.id);

}
$(document).on('click', '.js-open-quickview', function(e) {
  	e.preventDefault();
  	var href = $(this).attr('href');
  	$('#popup-quickview .quickview-popup-content').html('');
  	$('#popup-quickview').removeClass('loaded');
  	$.magnificPopup.open({
	    items: {
	      src: '#popup-quickview' 
	    },
	    type: 'inline',
	    mainClass: 'modal_quickview_popup mfp-fade',
	    removalDelay: 300
	});
  	$.ajax({
	    method: "GET",
	    url: href,
	    data: {"view": "quickview"},
	    xhrFields: {
	      withCredentials: true
	    },
	    dataType: 'html',
	    success: function(response) {
	      var pHtml = $(response).find('.product-quickview-container').first().html();
	      $('#popup-quickview .quickview-popup-content').html(pHtml);
	      if (typeof ReloadSmartWishlist !== "undefined" && $.isFunction(ReloadSmartWishlist)) ReloadSmartWishlist();
	      initQuickviewJs();
	    } 
	});
});
$(document).on('click', '#popup-quickview .mfp-close', function(e) {
    e.preventDefault();
    $.magnificPopup.close();
	if (typeof istockCloseQv !== 'undefined' && typeof istockCloseQv === 'function') {
	    istockCloseQv();
     }
});



/* remove identifier on filter options tag */
$(document).ready(function(){
var tagLabels = $('.filter-list li label');
  for(var i = 0; i < tagLabels.length; i++){
   tagLabels.eq(i).html(tagLabels.eq(i).html().replace('taille-', '').replace('diametre-', ''));
  }
});

var ur = window.location.href;
if(ur.includes('/challenge#contact_form')){
var bt = 0; var timerbt = setInterval(function(){
  if(jQuery('button[class*="CloseButton"]').length) {
	jQuery('button[class*="CloseButton"]').click();
clearInterval(timerbt);}if( bt > 500){clearInterval(timerbt);}bt++;}, 50);


}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}



jQuery(document).ready(function(){
   jQuery('input.btn.popup-button').click(function(){
		setCookie("popup-duralex-fr", "1", 1);
  }); 
   jQuery('span.close-popup').click(function(){
     setCookie("popup-duralex-fr", "1", 1);
  }); 
});

  function setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        var expires = "expires=" + d.toGMTString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        $('body').removeClass('open-popup');
    }

 function getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(";");
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == " ") {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }
 function popupCookie() {
    function checkCookie() {
        var counter = getCookie("popup-duralex-fr");
        if (counter == "") {
            $('body').addClass('open-popup');
        }
    }

    checkCookie();

}
function popupNewletter()
  {
     $('#popup-newsletter').css("display","block");
  }
  setTimeout(function(){ 
    if(jQuery('body').hasClass('open-popup')){
    popupNewletter();
  }
  },60000);
setTimeout(function(){ 
  if(jQuery('body').hasClass('template-index')){
    popupCookie();
  }
	
}, 900);

/* country selector active or inactive */
jQuery(document).ready(function(){
	jQuery(".country_select_wrapper").unbind("click").on('click', function(e) {
		if(jQuery('.country_select_wrapper .language_list').hasClass('active')) {
			jQuery('.country_select_wrapper .language_list').removeClass('active');
		} else {
			jQuery('.country_select_wrapper .language_list').addClass('active');
		}
	});
 });

jQuery(document).ready(function() {
  var a = 1;
  var frstli =jQuery(".ul-globo-dropdown-option li:first").attr("data-sku");

  setTimeout(function() {
    jQuery('.table_dec_div table:nth-child('+a+')').addClass(frstli);  
    var frstshow = jQuery(".table_dec_div table[sku="+frstli+"]").show();
  }, 1500);

  jQuery("li.swatches-options.select-option--dropdown.select-option").click(function(){
    var datasku = jQuery(this).attr("data-sku");
    var targetBox = jQuery("." + datasku);
    jQuery(".table_dec_div table").not(targetBox).hide();
    jQuery(targetBox).show();
  });


  jQuery('ul.value.ul-globo-dropdown-option li').each(function(n) {
    var data = $(this).attr('data-sku');
    jQuery('.table_dec_div table:nth-child('+a+')').attr("sku",data);    
    jQuery('.table_dec_div table:nth-child('+a+')').addClass(data);  
    a++;
  });  
    $(".video_show_div").click(function(){
    $("#video_play").css("display","block");
    $(".img_thumb").css("display","none"); 
    $("#video_play").trigger('play'); 
  });
  $(".img_thumbs").click(function(){
  	$("#video_play").css("display","none");
    $(".img_thumb").css("display","block"); 
    $("#video_play").trigger('pause'); 
  });
});

(function () {
  window.addEventListener('DOMContentLoaded', () => {
    const newsletterSubmit = document.querySelectorAll('.klaviyo_form_actions input[type="submit"]');

		setTimeout(() => {
			localStorage.setItem('from-newsletter', false);
		}, 5000)

		Array.prototype.forEach.call(newsletterSubmit, function (button) {
			button.addEventListener('click', (event) => {
				localStorage.setItem('from-newsletter', true);
			});
		})

		if(localStorage.getItem('from-newsletter') == 'true' || localStorage.getItem('from-newsletter') == true){    
      dataLayer.push({
				'event': 'newsletter_subscription'
      });
    }

		if(localStorage.getItem('from-login') == 'true' || localStorage.getItem('from-login') == true){    
      dataLayer.push({
          'event': 'login'
      });
      localStorage.setItem('from-login', false);
    }

		if(localStorage.getItem('from-signup') == 'true' || localStorage.getItem('from-signup') == true){ 
      dataLayer.push({
          'event': 'sign_up'
      });
      localStorage.setItem('from-signup', false);
    }
  });
})();